import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { CREATE_QUOTE_ACCESS_TYPE, useCreateQuoteAccessType } from 'growth-payments-core/hooks/quotes/useCreateQuoteAccessType';
import { getQuotesURL } from 'growth-payments-core/urls/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const quotesArticleUrl = 'https://knowledge.hubspot.com/articles/kcs_article/deals/how-do-i-create-quotes';
const QuotesPopoverEmptyState = () => {
  const {
    createQuoteAccessType
  } = useCreateQuoteAccessType();
  const shouldShowCPQEmptyState = createQuoteAccessType === CREATE_QUOTE_ACCESS_TYPE.CPQ;
  return /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
    image: "quotes",
    title: "draftPlugins.quotes.popover.zeroState.header",
    description: "draftPlugins.quotes.popover.zeroState.description",
    buttonLabel: shouldShowCPQEmptyState ? 'draftPlugins.quotes.popover.zeroState.buttonCPQ' : 'draftPlugins.quotes.popover.zeroState.button',
    buttonLink: shouldShowCPQEmptyState ? getQuotesURL() : quotesArticleUrl
  });
};
export default QuotesPopoverEmptyState;